var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "clone_svg__clone",
    viewBox: "0 0 82.53 90.03"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.82 73.15a15.94 15.94 0 01-15.94-15.94V18.76h-6.56A10.32 10.32 0 000 29.07v50.64A10.32 10.32 0 0010.32 90h46.89a10.32 10.32 0 0010.31-10.29v-6.56zM72.21 0H32.82a10.32 10.32 0 00-10.31 10.32v46.89a10.32 10.32 0 0010.31 10.31h39.39a10.32 10.32 0 0010.32-10.31V10.32A10.32 10.32 0 0072.21 0z"
  })));
}
export default SvgClone;